/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import cloud from "d3.layout.cloud";
import {
  setclearAll,
  setwordcloud,
  setwordcloudType,
} from "../../../../redux/actions/DisplayChart";
import { useSelector, useDispatch } from "react-redux";
import { simpleKFormatterOnly } from "../../../../redux/constants";

const WordRecloudChart = ({
  style,
  single,
  compare_key,
  deepDive,
  smartInsight,
  deepDiveTitle,
  id,
  isdownload,
  splitStatus,
  splitcolumncount,
}) => {
  const relRef = useRef();
  const [windowSize, setwindowSize] = useState(null);
  const [, setwords] = useState(null);
  const [final_data, setfinal_data] = useState(null); //final data format of wordcloud with name and data in single array
  const [single_data, setsingle_data] = useState(null); //final data format of wordcloud with text and values in single array
  const [legend, setlegend] = useState(false); // custom legends of wordcloud data
  const [myArray, setMyArray] = useState([]); //data format for legends when typeof color is object
  //redux states
  const isWidgetEdit = useSelector((state) => state.Filter.isWidgetEdit);
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const wordcloudType = useSelector(
    (state) => state.DisplayChart.wordcloudType
  ); //whether wordcloud is regular or differential
  //condition to finally set data in words

  const getFinalWordData = () => {
    let words1;
    if (single?.length !== 0) {
      if (single[0]?.name || single[0]?.name === "") {
        words1 = final_data; //data nested data
      } else {
        words1 = single?.length >= 1 ? single_data : single[0];
      }
    } else {
      words1 = single;
    }
    setwords(words1);
  };

  const dispatch = useDispatch();
  //on click function of wordcloud chart
  const onWordcloudClick = (event) => {
    let obj;
    if (event?.colorType === "object") {
      obj = {
        x: event?.name,
        y: event?.text,
        split: compare_key ? compare_key : null,
      };
    } else {
      obj = {
        x: event?.text,
        y: event?.name,
        split: compare_key ? compare_key : null,
      };
    }

    obj && !deepDive && dispatch(setwordcloud(obj)); //set wordcloud values
    !deepDive && dispatch(setclearAll("wordcloud")); //clear all charts state except "wordcloud"
  };
  //on click function of toggle button regular and deffrential
  const onWordcloudButton = (event) => {
    dispatch(setwordcloudType(event.target.value));
  };
  //wordcloud callbacks like get colors and wordcloud click
  const callbacks = {
    getWordColor: (a) => {
      return a?.color;
    },

    // onWordClick: (event) => onWordcloudClick(event),
  };

  useEffect(() => {
    //function to set myArray data of legends when typeof color is object
    const data = () => {
      const myArray = [];
      if (single.some((x) => typeof x?.color === "object")) {
        for (let i = 0; i < single?.length; i++) {
          if (single[i]?.color !== "#000000") {
            for (let j = 0; j < single[i]?.data?.length; j++) {
              if (myArray?.length === 0) {
                myArray?.push({
                  color: single[i].color[j],
                  sentiment: single[i].data[j].text,
                });
              } else {
                var index = myArray.findIndex(
                  (x) =>
                    x.color === single[i].color[j] &&
                    x.sentiment === single[i].data[j].text
                );
                if (index === -1) {
                  myArray.push({
                    color: single[i].color[j],
                    sentiment: single[i].data[j].text,
                  });
                }
              }
            }
          }
        }
      }
      setMyArray(myArray);
    };

    //function to set single data when only text values is given in single prop
    const getSingleData = () => {
      if (single && single[0]?.text) {
        let arr = [];
        for (let i = 0; i < single?.length; i++) {
          arr.push({
            text: single[i]?.text,
            value: single[i]?.value,
            color: single[i]?.color !== "#000000" ? single[i]?.color : "#444",
          });
        }
        setsingle_data(arr);
      }
    };

    //function to set final data when name and data is given in single prop
    const getFinalData = () => {
      if (single && single[0]?.name) {
        let finat_result = [];
        let data1 = single;

        for (let i = 0; i < data1?.length; i++) {
          let data2 = data1[i]?.data;
          //first loop on data
          for (let j = 0; j < data2?.length; j++) {
            let name = data1[i].name;
            if (typeof single[i].color === "string") {
              finat_result.push({
                text: data2[j]?.text,
                value: data2[j]?.value,
                color: data1[i]?.color !== "#000000" ? data1[i]?.color : "#444",
                name: name ? name : undefined,
                colorType: "string",
              });
              setlegend(true);
            } else if (typeof single[i].color === "object") {
              //loop on x, y axix

              finat_result?.push({
                text: name,
                value: data2[j]?.value,
                color:
                  data1[i]?.color[j] !== "#000000"
                    ? data1[i]?.color[j]
                    : "#444",
                name: data2[j]?.text,
                colorType: "object",
              });

              setlegend(false);
            }
          }
        }

        setfinal_data(finat_result);
      }
    };
    getFinalData();
    getSingleData();
    data();
    getFinalWordData();
  }, [single]);

  //loop to apply colors in wordcloud
  for (let i = 0; i < single?.length; i++) {
    callbacks.getWordColor(single[i]?.color);
  }

  useEffect(() => {
    function updateSize() {
      setwindowSize(
        (relRef?.current?.clientWidth === undefined
          ? "551"
          : relRef?.current?.clientWidth) - 30
      );
    }
    window.addEventListener("resize", updateSize);
    // updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, [windowSize, isWidgetEdit]);

  // List of words
  var myWords = final_data ? final_data : single_data;

  useEffect(() => {
    if (myWords) {
      let fontBase =
        isWidgetEdit && myWords?.length >= 20
          ? 4
          : isWidgetEdit && myWords?.length < 20
          ? 8
          : myWords[myWords?.length - 1].value < 10
          ? 15
          : 10;
      let sqrt = Math.round(Math.sqrt(myWords[0].value)) > 100 ? 2 : 1;
      myWords?.map((el, i) => {
        let obj = el;

        obj.fontSize =
          sqrt === 2
            ? Math.round(Math.sqrt(Math.sqrt(el.value))) > 20
              ? 8 + fontBase
              : Math.round(Math.sqrt(Math.sqrt(el.value))) + fontBase
            : Math.round(Math.sqrt(el.value)) + fontBase;
        return obj;
      });
    }
    d3.select(
      `#my_dataviz__${
        compare_key
          ? compare_key?.replaceAll(/[^a-zA-Z0-9]/g, "")
          : deepDiveTitle
          ? deepDiveTitle?.replaceAll(/[^a-zA-Z0-9]/g, "")
          : id
      }_${id} svg`
    ).remove();
    // set the dimensions and margins of the graph

    var margin = { top: 0, right: 0, bottom: 0, left: 0 },
      width = windowSize - margin.left - margin.right,
      height = smartInsight
        ? 530
        : isdownload == true
        ? splitcolumncount === 2 || splitcolumncount === 3
          ? 170
          : 195
        : 410 - margin.top - margin.bottom;

    // append the svg object to the body of the page
    var svg = d3
      .select(
        `#my_dataviz__${
          compare_key
            ? compare_key?.replaceAll(/[^a-zA-Z0-9]/g, "")
            : deepDiveTitle
            ? deepDiveTitle?.replaceAll(/[^a-zA-Z0-9]/g, "")
            : id
        }_${id}`
      )
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var body = d3.select(
      `div#my_dataviz__${
        compare_key
          ? compare_key?.replaceAll(/[^a-zA-Z0-9]/g, "")
          : deepDiveTitle
          ? deepDiveTitle?.replaceAll(/[^a-zA-Z0-9]/g, "")
          : id
      }_${id}`
    );
    // Define the div for the tooltip
    var tooltip = body
      .append("div")
      .attr("class", "tooltip_img")
      .attr(
        "id",
        `tooltip_img_${
          compare_key
            ? compare_key?.replaceAll(/[^a-zA-Z0-9]/g, "")
            : deepDiveTitle
            ? deepDiveTitle?.replaceAll(/[^a-zA-Z0-9]/g, "")
            : "smartInsight"
        }`
      )
      .style("opacity", 0);

    // Constructs a new cloud layout instance. It run an algorithm to find the position of words that suits your requirements
    var layout =
      myWords &&
      cloud()
        .size([width, height])
        .words(
          myWords.map(function (d) {
            return d;
          })
        )
        .padding(8)
        .fontSize((d) => d.fontSize)
        .rotate(function () {
          return ~~(Math.random() * 2) * 0;
        })
        .on("end", draw);
    myWords && layout.start();

    function draw(words) {
      svg
        .append("g")
        .attr(
          "transform",
          "translate(" + layout.size()[0] / 2 + "," + layout.size()[1] / 2 + ")"
        )
        .selectAll("text")
        .data(words)
        .enter()
        .append("text")
        .style("font-size", (d) => d.size + "px")
        .style("cursor", "pointer")
        .style("fill", function (d, i) {
          return d?.color;
        })
        .attr("text-anchor", "middle")
        .attr("transform", function (d) {
          return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
        })
        .text(function (d) {
          return d.text;
        })
        // .on("click", (e, d) => onWordcloudClick(d))
        // create a tooltip
        .on("mouseover", function (event, d) {
          tooltip.style("opacity", 0.9);
          tooltip
            .html(d.text + " : " + simpleKFormatterOnly(d.value))
            .attr("data-value", d.value)
            .style(
              "left",
              smartInsight
                ? `${event.clientX - 120}px`
                : `${event.clientX + 10}px`
            )
            .style("top", event.clientY + "px")
            .style("position", "fixed");
        })
        .on("mouseout", function () {
          tooltip.style("opacity", 0);
        });
    }
  }, [myWords, windowSize]);

  return (
    <>
      <div
        ref={relRef}
        id={`my_dataviz__${
          compare_key
            ? compare_key?.replaceAll(/[^a-zA-Z0-9]/g, "")
            : deepDiveTitle
            ? deepDiveTitle?.replaceAll(/[^a-zA-Z0-9]/g, "")
            : id
        }_${id}`}
        style={{ minHeight: smartInsight && "52rem" }}
      />
      {/* Legends code */}
      {legend ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            textTransform: "capitalize",
            marginTop: "1.5rem",
          }}
        >
          {single.map((el, index) => {
            return (
              <span
                key={index}
                style={{
                  color: "#444",
                  fontSize: "small",
                  fontFamily: "Roboto Slab",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  marginRight: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <span
                  style={{
                    backgroundColor: el.color,
                    width: "1.2rem",
                    height: "1.2rem",
                    display: "inline-block",
                    marginRight: "1rem",
                  }}
                ></span>
                {el.name}
              </span>
            );
          })}
        </div>
      ) : (
        <div
          style={{
            display: smartInsight ? "none" : "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            minHeight: "4rem",
          }}
        >
          {myArray.map((el, index) => {
            return (
              <span
                key={index}
                style={{
                  color: "#444",
                  padding: "1rem",
                  fontSize: "small",
                  fontFamily: "Roboto Slab",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  marginRight: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <span
                  style={{
                    backgroundColor: el.color,
                    width: "1.2rem",
                    height: "1.2rem",
                    display: "inline-block",
                    marginRight: "1rem",
                  }}
                ></span>{" "}
                {el.sentiment}
              </span>
            );
          })}
        </div>
      )}
    </>
  );
};

export default WordRecloudChart;
